var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[_c('v-container',[_c('v-card',[_c('section',{staticClass:"tw-px-4 sm:tw-px-8 tw-inline-block tw-w-full tw-py-10"},[_c('router-view')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }